import { cn } from '@/lib/utils';

type InlineLinkProps = React.AnchorHTMLAttributes<HTMLAnchorElement>;

function InlineLink({ className, children, ...props }: InlineLinkProps) {
  return (
    <a
      className={cn(
        'text-primary underline decoration-primary/30 underline-offset-2 transition-colors hover:decoration-primary/80',
        className,
      )}
      {...props}
    >
      {children}
    </a>
  );
}

export { InlineLink };
